import fraudDetectionResource from "@/shared/resource/fraudDetection";
import { authorizedAxios } from "./authorizedAxios";
import { VerifyIdentityResponse, ValidateKbaQuizRequest } from "@/shared/types";
import {
  BankCustodian,
  FraudCheckActionLog,
  FraudCheckAdjudicationStatus,
  FraudCheckQueueDataOverride,
  FraudCheckQueueListResult,
  FraudCheckUser
} from "@/admin/types";

export function postVerifyIdentityRequest (employerCustodian: BankCustodian, isDirectSignup: boolean) {
  return authorizedAxios.post<VerifyIdentityResponse>(
    fraudDetectionResource.verify(),
    {
      isDirectSignup,
      custodian: employerCustodian,
    });
}

export function postValidateKbaQuiz (request: ValidateKbaQuizRequest) {
  return authorizedAxios.post<VerifyIdentityResponse>(fraudDetectionResource.validateKbaQuiz(), request);
}

export function postValidateKbaChallengeQuiz (request: ValidateKbaQuizRequest) {
  return authorizedAxios.post<VerifyIdentityResponse>(fraudDetectionResource.validateKbaChallengeQuiz(), request);
}

export function getFraudCheckList (pageNumber: number, search: string, filters: any) {
  return authorizedAxios.post<FraudCheckQueueListResult>(
    fraudDetectionResource.getFraudCheckList(), {pageNumber, searchTerm: search, filters}
  );
}
export function getFraudCheckDetail (queueId: number) {
  return authorizedAxios.get<FraudCheckUser>(fraudDetectionResource.getFraudCheckDetail(queueId));
}
export function setFraudCheckDetailAccepted (queueId: number) {
  return authorizedAxios.put<boolean>(fraudDetectionResource.setFraudCheckDetailAccepted(queueId));
}
export function setFraudCheckDetailRejected (queueId: number) {
  return authorizedAxios.put<boolean>(fraudDetectionResource.setFraudCheckDetailRejected(queueId));
}
export function setFraudCheckAdjudicationStatus (queueId: number,  adjudicationStatus: FraudCheckAdjudicationStatus) {
  return authorizedAxios.put<boolean>(fraudDetectionResource.setFraudCheckAdjudicationStatus(), {queueId, adjudicationStatus});
}
export function overrideUserData (queueId: number, dataOverride: FraudCheckQueueDataOverride) {
  return authorizedAxios.put<void>(fraudDetectionResource.overrideUserData(queueId), dataOverride);
}
export function getFraudCheckLogs (queueId: number) {
  return authorizedAxios.get<FraudCheckActionLog[]>(fraudDetectionResource.getFraudCheckLogs(queueId));
}